var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var SpreadsheetProcessorResultCtrl = function () {
    function SpreadsheetProcessorResultCtrl($scope) {
        var _this = this;

        _classCallCheck(this, SpreadsheetProcessorResultCtrl);

        this.$scope = $scope;
        this.errorDataPageSize = 20;

        if (this.resultData && this.resultData.data && this.resultData.data.errors) {
            this.$scope.spreadsheetUploadErrors = this.resultData.data.errors;
        }

        this.$scope.$watch('spreadsheetUploadErrors', function (errorData) {
            if (errorData) {
                if (errorData.length >= _this.errorDataPageSize) {
                    $scope.errorLimit = _this.errorDataPageSize;
                    $scope.showLessErrorsLink = false;
                    $scope.showErrorPageLinks = true;
                } else {
                    $scope.showErrorPageLinks = false;
                    $scope.showLessErrorsLink = true;
                }
            }
        });
    }

    _createClass(SpreadsheetProcessorResultCtrl, [{
        key: 'showLessSpreadSheetUploadErros',
        value: function showLessSpreadSheetUploadErros() {
            this.$scope.errorLimit = this.errorDataPageSize;
            this.$scope.showLessErrorsLink = false;
        }
    }, {
        key: 'showMoreSpreadSheetUploadError',
        value: function showMoreSpreadSheetUploadError() {
            this.$scope.errorLimit = this.$scope.spreadsheetUploadErrors.length;
            this.$scope.showLessErrorsLink = true;
        }
    }, {
        key: 'spreadsheetProcessor',
        value: function spreadsheetProcessor(isUpdateSpreadsheetScenario) {
            this.processor(isUpdateSpreadsheetScenario);
        }
    }]);

    return SpreadsheetProcessorResultCtrl;
}();

SpreadsheetProcessorResultCtrl.$inject = ['$scope', '$state', '$injector', '$http', 'ModalService', '$document', '$timeout', 'StateUtils'];

export default SpreadsheetProcessorResultCtrl;


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/gw-portals-policytransaction-common-angular/components/spreadsheetProcessorResult/spreadsheetProcessorResultCtrl.js
// module id = 1848
// module chunks = 0